import { useAccount } from 'wagmi'

import { Address, EvmAddress } from '~/utils/address'
import { Formatted } from '~/utils/address/types'

export const useConnectedAddress = ():
  Formatted<EvmAddress.Type> | undefined => {
  const { address } = useAccount()
  return Address.safeFormat(address, 'evm')
}
